import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InstitutionsInfoRoutingModule } from './institutions-info-routing.module';
import { InstitutionsInfoListComponent } from './institutions-info-list/institutions-info-list.component';
import { InstitutionsInfoCreateComponent } from './institutions-info-create/institutions-info-create.component';

@NgModule({
  declarations: [InstitutionsInfoListComponent, InstitutionsInfoCreateComponent],
  imports: [
    CommonModule,
    InstitutionsInfoRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InstitutionsInfoModule { }
